import React from 'react';
import { Popover } from "antd";
import Participant from '../Participant/videoRoom/Participant';
import { useState, useEffect } from 'react';

import usePublications from '../../hooks/usePublications/usePublications';

import ParticipantConnectionIndicator from '../ParticipantInfo/ParticipantConnectionIndicator/ParticipantConnectionIndicator';
import useParticipantsAudioToggle from '../../hooks/useParticpantsAudioToggle/useParticipantsAudioToggle';
import usePublicationIsTrackEnabled from '../../hooks/usePublicationIsTrackEnabled/usePublicationIsTrackEnabled';

const usrMenu = (handleClick: any) => (
	<div className="account-settings">
        <ul>
          <li onClick={() => {
            if(handleClick){
              handleClick();
            }
          }}>
           <a ><img src="/images/unmute-icon.png" />&nbsp;Mute</a>
        </li>
         </ul>
     </div>
  );

function ParticipantStripItem(props: any) {
    const { participant,currentUser,participants, participantList, activeCalls, index, selectedParticipant, showMute, guestMobileNumber,muteUnmuteAllParticipants, muteUnmuteParticipant, setSelectedParticipant } = props;

    const publication = usePublications(participant);
    const videoPublication = publication.filter(p => p.kind.toLowerCase() === 'video');
    const audioPublication = publication.find(p => p.kind === 'audio');

    let [showMuteOption, setShowMuteOption] =  useState('hide');
    let [status, setShowMuteStatus] =  useState(true);
    const [isParticipantsAudioEnabled, toggleParticipantsAudio] = useParticipantsAudioToggle();
    const isAudioEnabled = usePublicationIsTrackEnabled(audioPublication);

    let toggleShowHide = () => {
  
      if(showMuteOption == 'hide'){
        setShowMuteOption('show')
      } else {
        setShowMuteOption('hide')
      }
  
    }
    let muteUnmuteStatus = (status: any) => {
      if(status == true){
        setShowMuteStatus(false)
      } else {
        setShowMuteStatus(true)
      }
  
    }
 

    //if (!videoPublication.length) return <></>;


    let participantName = participant.identity;
    if (participantName) {
      participantName = participantName.split("_")[0];
      if (participantName.toLowerCase().includes("screenshare")) participantName = participantName.replace('screenshare', '');
    }
 
    if(participantList){
      for(let i of participantList){
         if(i.mobileNumber == participant.identity){
          participantName = i.name
         }
      }
      
    }


    let callParticipant = activeCalls.find((activeCall: any) => {
      if (participant.identity.indexOf(activeCall.mobileNumber) !== -1) {
        return true;
      }
      let patientName = activeCall.patient.split(" ")[0] + (activeCall.patient.split(" ")[1] ? activeCall.patient.split(" ")[1] : "");
      if (participant.identity.indexOf(patientName) !== -1) {
        return true;
      }
      return false;
    })
    if (!videoPublication.length) return (<div>
      <header className="headermenu">
        <ParticipantConnectionIndicator participant={participant} />
        <h3>{participantName} </h3>

        {false && (showMute && (callParticipant && callParticipant.isMute !== "true")) && <div className="menu-cont">
          <Popover id="userdropdownMenu" placement="bottomRight" content={usrMenu(callParticipant ? () => muteUnmuteParticipant(callParticipant.callId) : undefined)} trigger="click">
            <div className="thumb-menu">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
            </div>
          </Popover>
        </div>}
        
      </header>
      <div className="participant-single room-thumbnail participant" key={index}>
        <Participant
        guestMobileNumber={guestMobileNumber}
        muteUnmuteParticipant={muteUnmuteParticipant}
        muteUnmuteAllParticipants={muteUnmuteAllParticipants}
        activeCalls={activeCalls}
        currentUser={currentUser}
          key={participant.sid}
          participant={participant}
          localParticipantFlag={false}
          isSelected={selectedParticipant === participant}
          onClick={() => {
            setSelectedParticipant(participant)
          }}
        />
      </div>
    </div>);

        return (<div>
          <header className={!videoPublication.length? "hideParticipant" : "headermenu"}>
            <ParticipantConnectionIndicator participant={participant} />
            <h3>{participantName} 
           
            </h3>
            {muteUnmuteAllParticipants && 
              <div className="menu-cont">
                <Popover id="userdropdownMenu" placement="bottomRight" >
                  <div className="thumb-menu" onClick={() => toggleShowHide()}>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                  </div>

                </Popover>
                {showMuteOption == "show" && <div id="userdropdownMenuItem" >
                  <div className="account-settings top-4">
                    <ul>
                      {isAudioEnabled == true ? 
                      <li onClick={() => muteUnmuteParticipant(currentUser, true, participant, activeCalls)} >
                        <a><img src="/images/unmute-icon.png" />&nbsp;
                          <span>Mute</span>
                        </a>
                      </li> :
                        <li onClick={() => muteUnmuteParticipant(currentUser, false, participant, activeCalls)} >
                          <a><img src="/images/unmute-icon.png" />&nbsp;
                            <span>Unmute</span>
                          </a>
                        </li>}
                    </ul>
                  </div>
                </div>}
              </div>
            }
            {false && (showMute && (callParticipant && callParticipant.isMute !== "true")) && <div className="menu-cont">
              <Popover id="userdropdownMenu" placement="bottomRight" content={usrMenu(callParticipant ? () => muteUnmuteParticipant(callParticipant.callId) : undefined)} trigger="click">
                <div className="thumb-menu">
                  <div className="circle"></div>
                  <div className="circle"></div>
                  <div className="circle"></div>
                </div>
              </Popover>
            </div>}
          </header>
          <div className="participant-single room-thumbnail participant" key={index}>
            <Participant
              guestMobileNumber={guestMobileNumber}
              currentUser={currentUser}
              activeCalls={activeCalls}
              muteUnmuteParticipant={muteUnmuteParticipant}
              muteUnmuteAllParticipants={muteUnmuteAllParticipants}
              key={participant.sid}
              participant={participant}
              localParticipantFlag={false}
              isSelected={selectedParticipant === participant}
              onClick={() => {
                setSelectedParticipant(participant)
              }}
            />
          </div>
        </div>)
}

export default ParticipantStripItem;